import Marquee from "react-fast-marquee";

const items = ["Editorial", "Laufsteg", "Werbung", "Print", "Lookbook", "Kampagne"];

export default function EditorialMarquee() {
  return (
    <div className="bg-sand border-y border-line/60 py-8 md:py-10" data-testid="marquee">
      <Marquee speed={38} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic font-light text-4xl md:text-6xl text-charcoal px-8 md:px-14">
              {t}
            </span>
            <span className="text-linen text-2xl md:text-3xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
